import { apiV1 } from "@/store";

const state = {
  documentEmailPayload: {
    emailAddress: "",
    signatureRequestId: ""
  },
  signatureEmailPayload: {
    email: "",
    signatureRequestId: ""
  },
  signatureCreationPayload: {
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    mobile_phone: "" | undefined,
    mailing_address: "" | undefined,
    mailing_city: "" | undefined,
    mailing_state: "" | undefined,
    mailing_postal_code: "" | undefined,
    insurance_id: "" | null,
    unit_id: "" | 0,
    lease_number: ""
  },
  signatureRequest: {
    signature_request_id: "",
    is_complete: false,
    is_declined: false,
    files_url: "",
    signatures: [],
    title: ""
  },
  signatureRequestsPayload: {
    page: 0 | null,
    perPage: 0 | null,
    query: ""
  },
  signatureRequests: [],
  totalCount: 0,
  loading: false,
  userAdmin: false
};

const actions = {
  getSignatureRequests: ({ commit, dispatch }, signatureRequestsPayload) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`esign/signature-requests`, {
        params: signatureRequestsPayload
      })
        .then((resp) => {
          commit("setSignatureRequests", resp.data.documents);
          commit("setSignatureRequestsCount", resp.data.total_count);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSignatureRequest: ({ commit, dispatch }, signatureRequestId) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`esign/signature-requests/${signatureRequestId}/signature-url`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createSignatureRequest: ({ commit, dispatch }, signatureCreationPayload) => {
    return new Promise((resolve, reject) => {
      apiV1.post(`esign/signature-requests`, signatureCreationPayload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  emailSignatureRequest: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.post(`esign/signature-requests/${payload.signatureRequestId}/email-url`, payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  emailCompletedSignatureRequest: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.post(`esign/signature-requests/${payload.signatureRequestId}/email-document`, payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteSignatureRequest: ({ commit, dispatch }, signatureRequestId) => {
    return new Promise((resolve, reject) => {
      apiV1.delete(`esign/signature-requests/${signatureRequestId}`)
        .then((resp) => {
          dispatch("getSignatureRequests");
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  emailCompletedDocument: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.post(`esign/signature-requests/${payload.signatureRequestId}/email-document`,
        { email: payload.emailAddress })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateLoading: ({ commit, dispatch }, isLoading) => {
    commit("setLoading", isLoading);
  },
  updateSignatureRequests: ({ commit, dispatch }, signatureRequest) => {
    commit("setSignatureRequests", signatureRequest.signatures);
  }
};

const mutations = {
  setSignatureRequests: (state, signatureRequests) => {
    state.signatureRequests = signatureRequests;
  },
  resetDocumentManagerState: (state) => {
    state.signatureRequests = [];
  },
  setSignatureRequestsCount: (state, totalCount) => {
    state.totalCount = totalCount;
  },
  setLoading: (state, isLoading) => {
    state.loading = isLoading;
  },
  errorMessage: (state, message) => {
    state.messageType = "error";
    state.snackbar = true;
    state.snackbarMessage = message;
  },
  successMessage: (state, message) => {
    state.messageType = "success";
    state.snackbar = true;
    state.snackbarMessage = message;
  }
};

export default {
  state,
  actions,
  mutations
};
